import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import HotelBooking from "../HotelBooking";

const SESSION_KEY_PREFIX = "rc_hotel_handoff_";

export function stashHotelHandoff(hotelCode, data) {
  try {
    sessionStorage.setItem(SESSION_KEY_PREFIX + hotelCode, JSON.stringify(data));
  } catch { }
}

function readHotelHandoff(hotelCode) {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY_PREFIX + hotelCode);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function buildHotelBookingUrl(hotelCode, { checkIn, checkOut, userId } = {}) {
  const params = new URLSearchParams();
  if (checkIn) params.set("check_in", checkIn);
  if (checkOut) params.set("check_out", checkOut);
  if (userId) params.set("user_id", userId);
  const qs = params.toString();
  return `/trip-planner/hotel/${encodeURIComponent(hotelCode)}${qs ? `?${qs}` : ""}`;
}

export default function HotelBookingPage() {
  const { hotelCode } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [handoff, setHandoff] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setHandoff(readHotelHandoff(hotelCode));
    setReady(true);
  }, [hotelCode]);

  if (!ready) return null;

  const checkIn = searchParams.get("check_in") || handoff?.check_in || "";
  const checkOut = searchParams.get("check_out") || handoff?.check_out || "";
  const userId = searchParams.get("user_id") || handoff?.userId || "";

  const hotel = {
    hotel_code: hotelCode,
    ...(handoff || {}),
    check_in: checkIn,
    check_out: checkOut,
  };

  const handleClose = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/trip-planner");
  };

  return (
    <>
      {/* Navbar same as TripPlanner */}
      <Navbar />

      {/* Hotel Booking Page */}
      <div style={{ paddingTop: "70px" }}>
        <HotelBooking
          hotel={hotel}
          userId={userId}
          hotelTest={true}
          onClose={handleClose}
          fullPage={true}
        />
      </div>
    </>
  );
}